import { Component, effect, ElementRef, inject, OnDestroy, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { WebsocketLaravelReverb } from '../home/services';
import { CustomRouteService } from 'src/app/pages/custom-route/services';
import { CHANNEL_START_ROUTE_NAME, START_ROUTE_EVENT } from '../home/config';
import { filter, take } from 'rxjs';

@Component({
  selector: 'app-standby',
  standalone: true,
  imports: [
    
  ],
  templateUrl: './standby.component.html',
  styleUrls: ['./standby.component.scss'],
})
export class StandbyComponent implements OnDestroy {
  public videoRef = viewChild<ElementRef<HTMLVideoElement>>('videoRef');
  
  private _router = inject(Router);
  private _websocketLaravelReverbService = inject(WebsocketLaravelReverb);
  private _customRouteService = inject(CustomRouteService);
  
  private _audioPlayer: HTMLAudioElement | null = null;
  
  constructor() {
    this._playAudio('/assets/fitur-2026/audios/standby.wav');
    
    this._subscribeToChannelStartRoute();
  }
  
  playVideo = effect(() => {
    const videoRef = this.videoRef();
    if (!videoRef) return;
    
    const videoEl = videoRef.nativeElement;
    videoEl.muted = true;
    videoEl.playsInline = true;
    
    const playPromise = videoEl.play();
    if (playPromise !== undefined) {
      playPromise.then(_ => {

      })
      .catch(error => {
        console.error('Error attempting to play', error);
      });
    }
  }, { allowSignalWrites: true });
  
  private _subscribeToChannelStartRoute(): void {
    this._websocketLaravelReverbService
      .subscribeToChannel(CHANNEL_START_ROUTE_NAME, START_ROUTE_EVENT)
      .pipe(
        filter((data: any) => !!data?.token),
        take(1) // <- se desuscribe solo al primer token válido
      )
      .subscribe({
        next: (data: any) => {
          this._router.navigate(['/home/route', data.token]);
        },
        error: (err: any) => console.error('Error en canal:', err),
      });
  }
  
  private _playAudio(src: string): void {
    this._stopAudio();
    this._audioPlayer = new Audio(src);
    this._audioPlayer.loop = true;
    this._audioPlayer.volume = 0.15;
    this._audioPlayer.play().catch(err => {
      console.error('Error reproduciendo audio:', err);
    });
  }
  
  private _stopAudio(): void {
    if (this._audioPlayer) {
      const fadeDuration = 800; // ms
      const steps = 20;
      const stepTime = fadeDuration / steps;
      const initialVolume = this._audioPlayer.volume;
      let currentStep = 0;

      const fade = () => {
        currentStep++;
        const newVolume = initialVolume * (1 - currentStep / steps);
        this._audioPlayer!.volume = Math.max(newVolume, 0);
        if (currentStep < steps) {
          setTimeout(fade, stepTime);
        } else {
          this._audioPlayer!.pause();
          this._audioPlayer!.currentTime = 0;
          this._audioPlayer = null;
        }
      };

      fade();
    }
  }
  
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    // fade out audio
    this._stopAudio();
  }
}
